import { parseAsStringEnum, useQueryState } from "nuqs";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { AdminClubsList } from "./admin-clubs-list";
import { AdminDetailedUserList } from "./admin-detailed-user-list";
import { AdminPlayersList } from "./admin-players-list";

export function AdminPage() {
  const [activeTab, setActiveTab] = useQueryState("tab", parseAsStringEnum(["players", "clubs", "users"]).withDefault("users"));

  return (
    <Tabs defaultValue={activeTab} className="p-2 sm:p-4">
      <TabsList>
        <TabsTrigger value="users" onClick={() => setActiveTab("users")}>
          Users
        </TabsTrigger>
        <TabsTrigger value="players" onClick={() => setActiveTab("players")}>
          Players
        </TabsTrigger>
        <TabsTrigger value="clubs" onClick={() => setActiveTab("clubs")}>
          Clubs
        </TabsTrigger>
      </TabsList>
      <TabsContent value="users" asChild>
        <AdminDetailedUserList />
      </TabsContent>
      <TabsContent value="players" asChild>
        <AdminPlayersList />
      </TabsContent>
      <TabsContent value="clubs" asChild>
        <AdminClubsList />
      </TabsContent>
    </Tabs>

  );
}
